import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import BaseInput from "../../../toolkit/baseInput";
import IInput from "../iInput/IInput";
import ISelectProps from "./ISelect.props";
import ISelectState from "./ISelect.state";

export default class ISelect extends IInput<ISelectProps, ISelectState> {
  state = {
    value: "",
    options: [],
    isExpanded: false
  };

  componentDidMount(): void {
    if (this.props.init) {
      this.setState(
        {
          value: this.props.init
        },
        () => super.triggerInput()
      );
    } else {
      super.triggerInput();
    }

    this.mapOptions();
  }

  componentDidUpdate(prevProps): void {
    if (this.props.init != prevProps.init) {
      this.setState({
        value: this.props.init
      });
    }

    if (this.props.data != prevProps.data) {
      this.mapOptions();
    }
  }

  onChange = evt => {
    const value = evt.target.value;
    this.props.setter(this.props.name, value);
    this.props.onChange && this.props.onChange(value);
    this.setState({ value });
  };

  toggleExpanded = () => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onExpandRow) {
      this.props.onExpandRow();
    }

    this.setState({ isExpanded: !this.state.isExpanded });
  };

  mapOptions() {
    const emptyOption = {
      value: "",
      label: this.props.emptyLabel || "Seleccione"
    };

    const data = (this.props.data && this.props.data) || [];
    const options = this.props.mapOption
      ? data.map(this.props.mapOption)
      : data;
    this.setState({
      options: [emptyOption, ...options]
    });
  }

  renderCollapsed = () => {
    const selectedOption = this.state.options.find(
      o => o.value === this.state.value
    );
    const displayValue =
      selectedOption && selectedOption.value !== ""
        ? selectedOption.label
        : "---";

    return (
      <div
        onClick={this.toggleExpanded}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 10px",
          backgroundColor: this.props.disabled ? "unset" : "#f5f5f5",
          borderRadius: "4px",
          cursor: this.props.disabled ? "default" : "pointer",
          minHeight: "32px",
          border: this.props.disabled ? "unset" : "1px solid #e0e0e0",
          transition: "all 0.2s ease",
          lineHeight: "19px"
        }}
        onMouseEnter={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#ebebeb";
          }
        }}
        onMouseLeave={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#f5f5f5";
          }
        }}
      >
        <div
          style={{
            color:
              selectedOption && selectedOption.value !== "" ? "#333" : "#999",
            fontSize: "14px"
          }}
        >
          {this.props.cellFormatter
            ? this.props.cellFormatter(displayValue)
            : displayValue}
        </div>
        {!this.props.disabled && (
          <FontAwesomeIcon
            icon={faEdit}
            color="#999"
            style={{
              marginLeft: "8px",
              marginBottom: "4px",
              flexShrink: 0,
              fontSize: "12px"
            }}
          />
        )}
      </div>
    );
  };

  render() {
    if (this.props.hidden) {
      return null;
    }

    const isExpanded = this.props.rowExpanded || this.state.isExpanded;
    const input = (
      <BaseInput
        label={this.props.onTable ? undefined : this.props.label}
        name={this.props.name}
        type="select"
        id={`${this.props.formKey || ""}-${this.props.name}`}
        size={"sm"}
        disabled={this.props.disabled || this.props.isLoading}
        value={this.state.value}
        options={this.state.options}
        onChange={this.onChange}
        errors={
          this.props.dirty && this.props.message ? [this.props.message] : null
        }
      />
    );

    if (this.props.onTable) {
      if (this.props.cellCollapsed && !isExpanded) {
        return (
          <td className={this.props.classCol || ""}>
            {this.renderCollapsed()}
          </td>
        );
      }
      return <td className={this.props.classCol || ""}>{input}</td>;
    }

    return <div className={this.btsClassName()}>{input}</div>;
  }
}
